package world.phantasmal.psolib

enum class Episode {
    I,
    II,
    IV;

    fun toInt(): Int = when(this) {
        I -> 1
        II -> 2
        IV -> 4
    }

    companion object {
        fun fromInt(episode: Int) = when (episode) {
            1 -> I
            2 -> II
            4 -> IV
            else -> error("$episode is invalid.")
        }

        /** Maps the `set_episode` bytecode argument (0=I, 1=II, 2=IV) to an Episode. */
        fun fromBytecodeValue(value: Int): Episode? = entries.getOrNull(value)
    }
}
